<script>
    import PreviewElement from "./PreviewElement";
    import AffiliatesRegistationElement from "../../components/pagesbuilder/elements/AffiliatesRegistationElement";
    import {mapState, mapActions, mapGetters} from "vuex";

    export default {
        name: "PreviewLeadWrapperElement",
        mixins: [
            PreviewElement,
            AffiliatesRegistationElement
        ],
        computed: {
            ...mapGetters('user', ['isLoggedIn'])
        },
        mounted(){
            const currentStatus = (this.isLoggedIn)? 'logged-in' : 'logged-out';            
            this.changeView(currentStatus);

            this.initTermLinks();
            //Scroll the page
            const offsetTop = $(this.myNode).offset().top;
            if($.getURLvar('affiliateSignin')){                
                setTimeout(function(){
                    $("body,html").animate({scrollTop: offsetTop - $('.lw-topbar').height()},500);
                }, 500);
            }
        },
        methods: {
            initTermLinks(){
                const $termLinks = $(this.myNode).find('.js-affiliate-terms-display');
                $termLinks.fancybox({
                    "type":"iframe",
                    fitToView: false,
                    autoSize: false,
                    autoDimensions: false,
                    "height": '80%',
                    "href" :'/pages/affiliate-program-terms',
                    afterLoad:function(){                
                        var $pageWrapperClone = $('body',$('.fancybox-iframe').contents())
                            .find('#pageContainer').clone();
                        $pageWrapperClone.find('.lw-topbar, .lw-footer').remove();    
                        $('body',$('.fancybox-iframe').contents())
                            .find("*").remove();
                        $('body',$('.fancybox-iframe').contents())
                            .append($pageWrapperClone);
                    }
                });
            }
        }

    }
</script>

